<template>
  <div class="ui-feedback-stat-become-our-supplier">
    <!--  -->
    <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
      <div class="feedback-popup-stat">
        <notifications group="cartcheckout" position="top left" animation-name="v-fade-left" width="100%" />
        <layout-loader v-show="loading"/>
        <form v-if="!success" class="feedback-form" @submit.prevent="submit">
          <input autofocus class="feedback-input--name" name="company" v-model="form.company" placeholder="Company name" type="text" required />
          <select class="select-form-feedback" name="furniture" v-model="form.furniture">
            <option value="">Furniture segment</option>
            <option value="office furniture">office furniture</option>
            <option value="bedroom (beds, mattresses, sleeping products)">bedroom (beds, mattresses, sleeping products)</option>
            <option value="dining room - sofa, chairs, armchairs, consol tables">dining room - sofa, chairs, armchairs, consol tables</option>
            <option value="kitchen room">kitchen room</option>
            <option value="lighting">lighting</option>
            <option value="outdoor furniture">outdoor furniture</option>
            <option value="wardrobe systems, library">wardrobe systems, library</option>
            <option value="spa zone">spa zone</option>
            <option value="fitness zone">fitness zone</option>
            <option value="horeca dining">horeca dining</option>
            <option value="decor">decor</option>
            <option value="artificial Plants">artificial Plants</option>
            <option value="Carpets">Carpets</option>
            <option value=""></option>
            <option value=""></option>
          </select>

          <vue-phone-number-input
              class="feedback-input--phone"
              id="input-phone"
              v-model="form.phone"
              name="phone"
              :defaultCountryCode="lang.toUpperCase()"
              required
              @update="updatePhoneNumber"
              error-color="red"
              :value="phoneMaskedValue"
              placeholder="Enter Mobile Number"
          />

          <input autofocus class="feedback-input--name" name="name" v-model="form.name" placeholder="Contact person name" type="text" required />
          <input autofocus class="feedback-input--name" name="email" v-model="form.email" placeholder="Contact person email" type="email" required />

          <ui-button class="sendButtonFeedback" type="submit">join</ui-button>
        </form>
        <div v-if="success" class="feedback-form-stat" v-html="this.$store.state.langs.SUCCESS"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import uiButton from '@/components/ui/ui-button'
export default {
  components: {
    uiButton,
    'vue-phone-number-input': VuePhoneNumberInput
  },
  props: {},
  data() {
    return {
      loading:false,
      success: false,
      phoneMaskedValue: '',
      mask: {
        mask: '+{0}(000)000-00-00',
        lazy: true
      },
      lang: this.$store.state.langs.LANGUAGE_ID,
      phonePlaceholder: '+_(___)___-__-__',
      updatePhoneNumber:null,
      form: {
        company: "",
        furniture: "",
        contact_details: "",
        name: "",
        phone: "",
        email: "",
        url: location.pathname,
        successType: "becomeOurSupplier",
        feadback: "feedback"
      }
    }
  },
  methods: {
      submit() {
          this.loading = true;
          this.$axios({
              url: '/ajax/index.php', method: 'post', params: this.form
          }).then(response => {
              if (response.status == 200) {
                  if(response.data.success){
                      this.success = true;
                  }else{
                      this.$notify({
                          group: 'cartcheckout',
                          title: 'error',
                          text: 'error',
                          type: 'error'
                      });
                  }
              }else{
                  this.$notify({
                      group: 'cartcheckout',
                      title: 'error',
                      text: 'error',
                      type: 'error'
                  });
              }
              this.loading = false;
          }).catch(e => {
              this.$notify({
                  group: 'cartcheckout',
                  title: 'error',
                  text: e,
                  type: 'error'
              });
              console.log('Error: ' + e)
          })
          this.loading = true;
      }
  },
  created(){}
}
</script>

<style lang="scss" scoped>
.ui-feedback-stat-become-our-supplier {
  position: relative;
  .sendButtonFeedback{
    margin-top: 10px;
    width: 100%;
  }
}
form{
  width: 100%;
  max-width: 500px;
}
input, .feedback-input--phone, .select-form-feedback {
  letter-spacing: .09em;
  border: none!important;
  border-bottom: 1px solid!important;
  border-radius: 0;
  max-width: 100%;
  margin-bottom: 10px;
}
.feedback-popup-stat {
  background: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
}
</style>
<style lang="scss">
  .feedback-input--phone .select-country-container {
    flex: 0 0 95px !important;
    width: 95px !important;
    min-width: 95px !important;
    max-width: 95px !important;
  }
</style>